import { log } from 'log';
import { prop } from 'ramda';
import { useEffect } from 'react';
import { useSocketSelector } from 'js/store/hooks';
import { usePrevious } from 'js/hooks/usePrevious';
import * as Types from 'js/components/tagTypes/Geofencing/types';

export const useOnReconnect = ({
    sdk,
    nextTime,
    triggerGeolocation,
    setTransactionID,
    setLicense,
    setNextTime
}: {
    sdk: Types.GeofencingSdkInstance | null;
    nextTime: number;
    triggerGeolocation: () => Promise<void>;
    setTransactionID: (transactionID: string | null) => void;
    setLicense: (license: string | null) => void;
    setNextTime: (nextTime: number) => void;
}) => {
    const connected = useSocketSelector(prop('connected'));
    const prevConnected = usePrevious(connected);

    useEffect(() => {
        if (connected === prevConnected || !connected) {
            return;
        }

        if (!sdk || !nextTime) {
            return;
        }

        log('gcInfo', { event: 'connectionReconnected' });

        // unset current timeout
        setTransactionID(null);
        setLicense(null);
        setNextTime(0);

        triggerGeolocation();
    }, [
        sdk,
        nextTime,
        connected,
        prevConnected,
        setTransactionID,
        setLicense,
        setNextTime,
        triggerGeolocation
    ]);
};
